export const STRINGS = {
  success_creation: 'Запись успешно создана',
  success_update: 'Запись успешно обновлена',
  success_deletion: 'Запись успешно удалена',
  success_deletion_multiple: 'Записи успешно удалены',
  string_error_limit_max: 'Превышена максимальная длина',
  string_error_limit_min: 'Недостаточная длина',
  string_error_required: 'Обязательное поле',
  placeholder_search_by_name_input: 'Поиск по наименованию',
  placeholder_search_input: 'Поиск',
  label_filters_control: 'Фильтры',
  nothing_was_found: 'Ничего не нашлось',
  form_error_empty_fields: 'Не все поля заполнены',
} as const
